<template>
  <div class="home" id="home">
    <HomeHero />
    <HomeCategories />
    <HomeTendencies />
    <HomeEnvironments />
    <InstaCarousel />
  </div>
</template>

<script>
import HomeHero from "../components/Home/Hero/HomeHero";
import HomeCategories from "../components/Home/Categories/HomeCategories";
import HomeTendencies from "../components/Home/Tendencies/HomeTendencies";
import HomeEnvironments from "../components/Home/Environments/HomeEnvironments";
import InstaCarousel from "../components/Shared/InstaCarousel";

export default {
  name: "home",
  components: {
    HomeHero,
    HomeCategories,
    HomeTendencies,
    HomeEnvironments,
    InstaCarousel,
  },
  metaInfo() {
    return {
      title: "Fibrillare - Móveis de Alumínio e Fibra Sintética",
    };
  },
  mounted() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  },
};
</script>

<style lang="scss" scoped></style>
